import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { getRibbonButtonSizedStyles } from "../../next/commonRibbonButtonStyles.styles";
import type { RibbonMenuButtonState } from "../../RibbonFlyoutAnchor/next";
import { useRibbonMenuButtonStyles } from "../../RibbonFlyoutAnchor/next";
import { menuTextContainerClass } from "@1js/acui-button";
import { customTokens, isNextStyleEnabled } from "@1js/acui-theme";
import { useMinimumTargetSizesIsEnabled } from "@1js/acui-experiments";
import React from "react";
import { AppContext } from "@1js/acui-context";
import { controlStylingConstants } from "@1js/acui-common";

const useMenuButtonStyles = makeStyles({
  medium: {
    paddingLeft: "0px",
    paddingTop: "0px",
    minWidth: "16px",
  },
  menuIcon: {
    marginRight: "1px",
    marginLeft: "2px",
    fill: customTokens.legacy_neutralDark,
  },
  small: {
    width: "12px",
    minWidth: "12px",
  },
  large: {
    borderTopWidth: "0px",
    height: "36px",
    minHeight: "36px",
    minWidth: "40px",
    width: "100%",
    [`& .${menuTextContainerClass}`]: {
      paddingTop: "0px",
    },
  },
});

const useMenuButtonStylesNext = makeStyles({
  menuIcon: {
    marginLeft: customTokens.spacingHorizontalNone,
    fill: customTokens.colorNeutralForeground1,
  },
  small: {
    width: "12px",
    minWidth: "12px",
    paddingLeft: customTokens.spacingHorizontalXXS,
    paddingRight: "1px",
  },
  medium: {
    paddingLeft: customTokens.spacingHorizontalXXS,
    paddingRight: "3px",
    minWidth: "16px",
  },
  large: {
    justifyContent: "flex-start",
    borderTopWidth: "0px",
    height: "36px",
    minHeight: "36px",
    minWidth: "40px",
    width: "100%",
    paddingTop: customTokens.spacingVerticalNone,
  },
  withMinTargetSize: {
    width: `${controlStylingConstants.minTargetSize}px`,
    minWidth: `${controlStylingConstants.minTargetSize}px`,
    padding: "0",
  },
});

export const useRibbonSplitButtonMenuButtonStyles = (
  state: RibbonMenuButtonState
): RibbonMenuButtonState => {
  const rootStyles = useMenuButtonStyles();
  const rootStylesNext = useMenuButtonStylesNext();

  const context = React.useContext(AppContext);
  const minimumTargetSizesEnabled = useMinimumTargetSizesIsEnabled(context);

  if (isNextStyleEnabled()) {
    state.root.className = mergeClasses(
      getRibbonButtonSizedStyles(
        state.size,
        rootStylesNext,
        minimumTargetSizesEnabled
      ),
      state.root.className
    );

    if (state.icon) {
      state.icon.className = mergeClasses(state.icon.className);
    }

    if (state.menuIcon) {
      state.menuIcon.className = mergeClasses(
        rootStylesNext.menuIcon,
        state.menuIcon.className
      );
    }
  } else {
    state.root.className = mergeClasses(
      getRibbonButtonSizedStyles(state.size, rootStyles),
      state.root.className
    );

    if (state.icon) {
      state.icon.className = mergeClasses(state.icon.className);
    }

    if (state.menuIcon) {
      state.menuIcon.className = mergeClasses(
        rootStyles.menuIcon,
        state.menuIcon.className
      );
    }
  }
  useRibbonMenuButtonStyles(state as RibbonMenuButtonState);
  return state;
};
